import ErrorFallback from 'Components/ErrorFallback'
import {
  ParameterCreatePage,
  ParameterEditPage,
  ParameterListPage
} from 'Services/ProductManagement/Features/Parameter/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function ParameterRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<ParameterListPage />} />
        <Route path=":parameterGroupCategory/:parameterId" element={<ParameterEditPage />} />
        <Route path=":parameterGroupCategory/create" element={<ParameterCreatePage />} />
      </Routes>
    </ErrorBoundary>
  )
}
export default ParameterRoot
